import React from 'react';
import { ArrowLeft, Mail, Globe, MapPin, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Contact() {
  const navigate = useNavigate();

  React.useEffect(() => { document.title = 'Kontakt & Support | 366Transfer Flughafentransfer'; }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <nav className="bg-white border-b border-slate-100 sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="p-2 hover:bg-slate-100 rounded-lg transition-colors" data-testid="contact-back-btn">
            <ArrowLeft size={20} className="text-slate-600" />
          </button>
          <a href="/" className="flex items-baseline gap-0.5">
            <span className="text-2xl font-extrabold text-orange-500">366</span>
            <span className="text-base font-semibold text-slate-800">Transfer</span>
          </a>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8" data-testid="contact-title">Kontakt</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Hauptadresse */}
          <div className="bg-slate-50 rounded-xl p-6 border border-slate-200" data-testid="contact-main-address">
            <div className="flex items-center gap-2 mb-4">
              <Building2 size={20} className="text-orange-500" />
              <h2 className="text-lg font-semibold text-slate-800">Hauptsitz</h2>
            </div>
            <div className="space-y-3 text-sm text-slate-700">
              <p className="font-semibold text-slate-900">366Transfer OU</p>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="text-slate-400 mt-0.5 shrink-0" />
                <p>
                  Tartu mnt 67/1-13b<br />
                  Tallinn - 10115<br />
                  Estland (EE)
                </p>
              </div>
            </div>
          </div>

          {/* Zweite Adresse */}
          <div className="bg-slate-50 rounded-xl p-6 border border-slate-200" data-testid="contact-second-address">
            <div className="flex items-center gap-2 mb-4">
              <MapPin size={20} className="text-orange-500" />
              <h2 className="text-lg font-semibold text-slate-800">Weitere Standorte</h2>
            </div>
            <div className="space-y-3 text-sm text-slate-700">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="text-slate-400 mt-0.5 shrink-0" />
                <p>
                  Fahrwangen, AG, Schweiz<br />
                  Marsa Alam, Rotes Meer, Ägypten
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Kontaktdaten */}
        <div className="mt-10 bg-white rounded-xl border border-slate-200 p-6" data-testid="contact-details">
          <h2 className="text-lg font-semibold text-slate-800 mb-4">Erreichen Sie uns</h2>
          <div className="space-y-4 text-sm text-slate-700">
            <div className="flex items-center gap-3">
              <Mail size={18} className="text-orange-500" />
              <a href="mailto:info@366transfer.com" className="hover:text-orange-600 transition-colors" data-testid="contact-email">
                info@366transfer.com
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Globe size={18} className="text-orange-500" />
              <a href="https://www.366transfer.com" target="_blank" rel="noopener noreferrer" className="hover:text-orange-600 transition-colors" data-testid="contact-website">
                www.366transfer.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
